import SERVICE_URL from "../config/API_DATA";
import HttpPost from "../http/httppost.js";
import Logger from "./logger.js";
import { FILE_NAME, LOG_TYPE } from "../config/API_DATA";

export default class CreditNote {
  static buildRequest(creditObj) {
    let returnValue = null;
    try {
       // let amount=creditObj.creditAmount.toString().split(",").join("");
       // amount=
        //amount=amount.toString().split(",").join("");
      let body = {
        b2b: creditObj.agents.b2bid,
        currencycode: creditObj.currency.code,
        amount: creditObj.creditAmount,
        paymentref: creditObj.reference,
        order: creditObj.bookingId!=null && creditObj.bookingId!="" ?creditObj.bookingId:null
      };
      returnValue = body;
    } catch (err) {
      let body = Logger.buildRequest(
        FILE_NAME.API_CREDIT_NOTE,
        "error in building body for CreditNote",
        err.toString(),
        "buildRequest",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
    return returnValue;
  }

  static async getResponse(pReqOptions) {
    let returnValue = null;
    try {
      returnValue = await HttpPost.makeHttpPostRequest(
        SERVICE_URL.CREATE_CREDIT_NOTE,
        pReqOptions
      );
    } catch (err) {
      let body = Logger.buildRequest(
        FILE_NAME.API_CREDIT_NOTE,
        "error in getting Response from  CreditNote ",
        err.toString(),
        "getResponse",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
    return returnValue;
  }
}
